import React, { useState, useEffect } from "react";

export default function WhatsAppChat() {
  const [open, setOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [message, setMessage] = useState(
    "Hello, I am interested in your export products. Could you please share more details about your products and export process?",
  );

  const phoneNumber = "917842069778";

  // Show tooltip after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTooltip(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const sendMessage = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="whatsapp-container">
        {/* Tooltip Message */}
        {showTooltip && !open && (
          <div className="whatsapp-tooltip">
            <span>💬 Need help? Chat with us!</span>
            <span
              className="tooltip-close"
              onClick={() => setShowTooltip(false)}
            >
              ✕
            </span>
          </div>
        )}

        {/* Floating WhatsApp Button */}
        <button
          className="whatsapp-btn"
          onClick={() => {
            setOpen(!open);
            setShowTooltip(false);
          }}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
            alt="WhatsApp"
            width="38"
          />
        </button>

        {/* Chat Box */}
        {open && (
          <div className="whatsapp-chat">
            <div className="chat-header">
              <span>WhatsApp Chat</span>
              <button className="close-btn" onClick={() => setOpen(false)}>
                ✕
              </button>
            </div>

            <textarea
              className="chat-input"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <button className="send-btn" onClick={sendMessage}>
              Send Message
            </button>
          </div>
        )}
      </div>

      <style>{`
      .whatsapp-container{
        position:fixed;
        bottom:25px;
        right:25px;
        z-index:9999;
      }

      /* Tooltip */
      .whatsapp-tooltip{
        position:absolute;
        bottom:80px;
        right:0;
        background:#fff;
        color:#333;
        padding:12px 16px;
        border-radius:12px;
        box-shadow:0 10px 30px rgba(0,0,0,0.25);
        font-size:14px;

        /* FIX WIDTH */
        min-width:200px;
        max-width:260px;  
        font-weight:700;
        /* TEXT FIX */
        line-height:1.4;
        white-space:normal;

        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;

        animation:fadeInUp 0.4s ease;
      }
        .whatsapp-tooltip::after{
        content:"";
        position:absolute;
        bottom:-6px;
        right:20px;
        width:12px;
        height:12px;
        background:white;
        transform:rotate(45deg);
        box-shadow: 0 8px 20px rgba(0,0,0,0.25);
      }

      .tooltip-close{
        margin-left:8px;
        cursor:pointer;
        font-weight:bold;
        color:#888;
      }

      .tooltip-close:hover{
        color:red;
      }

      /* Button */
      .whatsapp-btn{
        width:50px;
        height:50px;
        border-radius:50%;
        border:none;
        background:white;
        cursor:pointer;
        box-shadow:0 8px 25px rgba(0,0,0,0.3);
        transition:0.3s;
        display:flex;
        align-items:center;
        justify-content:center;
        animation:pulse 2s infinite;
      }

      .whatsapp-btn:hover{
        transform:scale(1.1);
      }

      /* Chat Box */
      .whatsapp-chat{
        width:270px;
        background:white;
        border-radius:12px;
        box-shadow:0 10px 30px rgba(0,0,0,0.25);
        margin-bottom:10px;
        padding:12px;
        animation:popup 0.3s ease;
      }

      .chat-header{
        display:flex;
        justify-content:space-between;
        align-items:center;
        font-weight:600;
        margin-bottom:8px;
        color:#075E54;
      }

      .close-btn{
        border:none;
        background:none;
        font-size:20px;
        cursor:pointer;
        color:#555;
      }

      .close-btn:hover{
        color:red;
      }

      .chat-input{
        width:100%;
        height:70px;
        border:1px solid #ddd;
        border-radius:6px;
        padding:6px;
        resize:none;
        margin-bottom:10px;
      }

      .send-btn{
        width:100%;
        padding:8px;
        border:none;
        background:#25D366;
        color:white;
        border-radius:6px;
        cursor:pointer;
        font-weight:600;
      }

      /* Animations */
      @keyframes popup{
        from{
          transform:translateY(20px);
          opacity:0;
        }
        to{
          transform:translateY(0);
          opacity:1;
        }
      }

      @keyframes fadeInUp{
        from{
          opacity:0;
          transform:translateY(10px);
        }
        to{
          opacity:1;
          transform:translateY(0);
        }
      }

      @keyframes pulse{
        0%{
          box-shadow:0 0 0 0 rgba(37,211,102,0.6);
        }
        70%{
          box-shadow:0 0 0 15px rgba(37,211,102,0);
        }
        100%{
          box-shadow:0 0 0 0 rgba(37,211,102,0);
        }
      }
      `}</style>
    </>
  );
}
